"use strict";
/*
 * Copyright (C) 2017-2020 HERE Europe B.V.
 * Licensed under Apache 2.0, see full license in LICENSE
 * SPDX-License-Identifier: Apache-2.0
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !exports.hasOwnProperty(p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Utility classes for working with geospatial data.
 *
 * @remarks
 *
 * @packageDocumentation
 */
__exportStar(require("./lib/coordinates/GeoBox"), exports);
__exportStar(require("./lib/coordinates/GeoBoxExtentLike"), exports);
__exportStar(require("./lib/coordinates/GeoCoordinatesLike"), exports);
__exportStar(require("./lib/coordinates/GeoCoordinates"), exports);
__exportStar(require("./lib/coordinates/GeoPointLike"), exports);
__exportStar(require("./lib/coordinates/LatLngLike"), exports);
__exportStar(require("./lib/projection/EarthConstants"), exports);
__exportStar(require("./lib/projection/EquirectangularProjection"), exports);
__exportStar(require("./lib/projection/IdentityProjection"), exports);
__exportStar(require("./lib/projection/Projection"), exports);
__exportStar(require("./lib/projection/MercatorProjection"), exports);
__exportStar(require("./lib/projection/TransverseMercatorProjection"), exports);
__exportStar(require("./lib/projection/SphereProjection"), exports);
__exportStar(require("./lib/tiling/FlatTileBoundingBoxGenerator"), exports);
__exportStar(require("./lib/tiling/HalfQuadTreeSubdivisionScheme"), exports);
__exportStar(require("./lib/tiling/QuadTreeSubdivisionScheme"), exports);
__exportStar(require("./lib/tiling/QuadTree"), exports);
__exportStar(require("./lib/tiling/SubTiles"), exports);
__exportStar(require("./lib/tiling/SubdivisionScheme"), exports);
__exportStar(require("./lib/tiling/TileKey"), exports);
__exportStar(require("./lib/tiling/TileKeyUtils"), exports);
__exportStar(require("./lib/tiling/TileTreeTraverse"), exports);
__exportStar(require("./lib/tiling/TilingScheme"), exports);
__exportStar(require("./lib/tiling/HereTilingScheme"), exports);
__exportStar(require("./lib/tiling/WebMercatorTilingScheme"), exports);
__exportStar(require("./lib/tiling/MercatorTilingScheme"), exports);
__exportStar(require("./lib/tiling/PolarTilingScheme"), exports);
__exportStar(require("./lib/math/Vector3Like"), exports);
__exportStar(require("./lib/math/Box3Like"), exports);
__exportStar(require("./lib/math/OrientedBox3Like"), exports);
__exportStar(require("./lib/math/MathUtils"), exports);
__exportStar(require("./lib/math/TransformLike"), exports);
__exportStar(require("./lib/math/OrientedBox3"), exports);
//# sourceMappingURL=index.js.map